"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_menu_1 = require("rc-menu");
var toArray_1 = tslib_1.__importDefault(require("rc-util/lib/Children/toArray"));
var Sider_1 = require("../../layout/Sider");
var tooltip_1 = tslib_1.__importDefault(require("../../tooltip"));
var reactNode_1 = require("../../util/reactNode");
var MenuContext_1 = tslib_1.__importDefault(require("./MenuContext"));
var MenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderItem = function (_a) {
            var siderCollapsed = _a.siderCollapsed;
            var _b = _this.props, level = _b.level, className = _b.className, children = _b.children, rootPrefixCls = _b.rootPrefixCls;
            var _c = _this.props, title = _c.title, icon = _c.icon, danger = _c.danger, rest = tslib_1.__rest(_c, ["title", "icon", "danger"]);
            return (React.createElement(MenuContext_1.default.Consumer, null, function (_a) {
                var _b;
                var _c;
                var inlineCollapsed = _a.inlineCollapsed, direction = _a.direction;
                var tooltipTitle = title;
                if (typeof title === 'undefined') {
                    tooltipTitle = level === 1 ? children : '';
                }
                else if (title === false) {
                    tooltipTitle = '';
                }
                var tooltipProps = {
                    title: tooltipTitle,
                };
                if (!siderCollapsed && !inlineCollapsed) {
                    tooltipProps.title = null;
                    // Reset `visible` to fix control mode tooltip display not correct
                    // ref: https://github.com/ant-design/ant-design/issues/16742
                    tooltipProps.visible = false;
                }
                var childrenLength = (0, toArray_1.default)(children).length;
                return (React.createElement(tooltip_1.default, tslib_1.__assign({}, tooltipProps, { placement: direction === 'rtl' ? 'left' : 'right', overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip") }),
                    React.createElement(rc_menu_1.Item, tslib_1.__assign({}, rest, { className: (0, classnames_1.default)((_b = {},
                            _b["".concat(rootPrefixCls, "-item-danger")] = danger,
                            _b["".concat(rootPrefixCls, "-item-only-child")] = (icon ? childrenLength + 1 : childrenLength) === 1,
                            _b), className), title: title }),
                        (0, reactNode_1.cloneElement)(icon, {
                            className: (0, classnames_1.default)((0, reactNode_1.isValidElement)(icon) ? (_c = icon.props) === null || _c === void 0 ? void 0 : _c.className : '', "".concat(rootPrefixCls, "-item-icon")),
                        }),
                        _this.renderItemChildren(inlineCollapsed))));
            }));
        };
        return _this;
    }
    MenuItem.prototype.renderItemChildren = function (inlineCollapsed) {
        var _a = this.props, icon = _a.icon, children = _a.children, level = _a.level, rootPrefixCls = _a.rootPrefixCls;
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || ((0, reactNode_1.isValidElement)(children) && children.type === 'span')) {
            if (children && inlineCollapsed && level === 1 && typeof children === 'string') {
                return (React.createElement("div", { className: "".concat(rootPrefixCls, "-inline-collapsed-noicon") }, children.charAt(0)));
            }
            return children;
        }
        return React.createElement("span", null, children);
    };
    MenuItem.prototype.render = function () {
        return React.createElement(Sider_1.SiderContext.Consumer, null, this.renderItem);
    };
    MenuItem.isMenuItem = true;
    return MenuItem;
}(React.Component));
exports.default = MenuItem;
//# sourceMappingURL=MenuItem.js.map